import { Action } from '@ngrx/store'
import { UXPage } from '../../core/models/ux-page'

export const INIT = '[Pages] Init'
export const GET = '[Pages] Get'
export const GET_SKIPPED = '[Pages] Get skipped'
export const GET_SUCCESS = '[Pages] Get Success'
export const GET_FAILED = '[Pages] Get Failed'

export class Init implements Action {
  readonly type = INIT
  constructor(public forceRefresh: boolean = false) {}
}
export class GetSkipped implements Action {
  readonly type = GET_SKIPPED
}
export class Get implements Action {
    readonly type = GET
}
export class GetSuccess implements Action {
    readonly type = GET_SUCCESS
    constructor(public payload: UXPage[]) {}
}
export class GetFailed implements Action {
    readonly type = GET_FAILED
    constructor(public payload: any) {}
}

export type Actions =
  Init
  | GetSkipped
  | Get
  | GetSuccess
  | GetFailed
